export default __webpack_public_path__ + "static/media/complaint.65bc0639.svg";